module.exports = __webpack_public_path__ + "static/media/consulenza2.add18900.png";